import moment from "moment";

import {
	ApiRequestGetParams,
	ApiRequestGetParamsRaw
} from "api/makeApiRequest";
import { formatForApiGetRequestIfDateOrTime } from "api/utils/formatForApiGetRequestIfDateOrTime";
import { formatForApiGetRequestIfBoolean } from "api/utils/formatForApiGetRequestIfBoolean";

export function formatDataForGetRequest(
	input: ApiRequestGetParamsRaw,
	allowBooleanFalse: boolean = true
): ApiRequestGetParams {
	const output: ApiRequestGetParams = {};
	for (const k in input) {
		let iter = input[k];

		if (iter === undefined) {
			continue;
		}

		iter = formatForApiGetRequestIfDateOrTime(iter) as Exclude<
			typeof iter,
			Date | moment.Duration
		>;

		if (iter === false && !allowBooleanFalse) {
			continue;
		}

		iter = formatForApiGetRequestIfBoolean(iter) as Exclude<
			typeof iter,
			boolean
		>;

		output[k] = iter;
	}
	return output;
}
